<script setup lang="ts">
    import { computed } from 'vue';
    import { useSearchContext } from '../composables/searchContext';
    import DisciplineFilter from './DisciplineFilter.vue';
    import FacetGroup from './FacetGroup.vue';
    import SeriesFacet from './SeriesFacet.vue';
    const search = useSearchContext();
    const groupedFacetIds = computed(() => new Set(search.primaryFacetGroups.value.flatMap((group) => group.facets.map((facet) => facet.AttributeTypeSk))));
    const standardFacets = computed(() => search.productFacets.value.filter((facet) => !groupedFacetIds.value.has(facet.AttributeTypeSk)));
    function divisionUrl(division: string): string {
        const query = encodeURIComponent(search.state.query.replaceAll(':', '158H'));
        return `/search/pg/1/sortOrder/r/div/${division}/qry/${query}`;
    }
    const divisions = computed(() => [
        { key: 'primary', label: 'Primary', count: search.divisionCounts.primary },
        { key: 'secondary', label: 'Secondary', count: search.divisionCounts.secondary },
        ...(search.config.isB2BUser ? [{ key: 'universityb2b', label: 'University', count: search.divisionCounts.university }, { key: 'vetb2b', label: 'VET', count: search.divisionCounts.vet }] : [])
    ]);
</script>

<template>
    <div :class="['filter-series', { 'mobile-panel-open': search.mobileFiltersVisible.value }]">
        <div v-if="search.state.division !== 'all'" id="divFilter" class="narrowdisciplinehedertop">
            <DisciplineFilter />
            <section v-if="search.state.division === 'primary' && search.seriesFacets.value.length" class="parentfacet-wholebody1">
                <div class="series-header">
                    <h3 class="refine facet-header">Filter by Series</h3>
                </div>
                <SeriesFacet v-for="facet in search.seriesFacets.value" :key="facet.SeriesAttributeTypeValueSk" :facet="facet" />
            </section>

        </div>
    </div>
</template>
